import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import CallConsole from "./components/crm/CallConsole";
import { DialogProvider } from "./components/Dialog";
import { AuthProvider } from "./context/AuthContext";
import { CrmSessionProvider } from "./context/CrmSessionContext";
import { MarketProvider } from "./context/MarketContext";
import { PhoneProvider } from "./context/PhoneContext";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement,
);

root.render(
  <BrowserRouter>
    <DialogProvider>
      <MarketProvider>
        <AuthProvider>
          <CrmSessionProvider>
            {/* PhoneProvider dentro de CrmSessionProvider: el softphone gatea
                sus efectos (prefs, heartbeat, Mercure) con la sesión CRM. La
                CallConsole (modal flotante arrastrable) es global: la llamada
                sigue viva al navegar. */}
            <PhoneProvider>
              <App />
              <CallConsole />
            </PhoneProvider>
          </CrmSessionProvider>
        </AuthProvider>
      </MarketProvider>
    </DialogProvider>
  </BrowserRouter>,
);
